import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-insight-card-loading',
  templateUrl: './insight-card-loading.component.html',
  styleUrls: ['./insight-card-loading.component.scss']
})
export class InsightCardLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
